<template>
	<div class="col-12">
		<div class="mb-3 text-center">
			<hr />
			<strong>تیکت ها</strong>
			<hr />
		</div>
		<div v-if="!isLoading && items.length == 0" class="text-center pt-5">
			<p>لیست تیکت های شما خالی است. برای شروع میتوانید یک تیکت ارسال نمایید.</p>

			<router-link class="btn btn-outline-dark" :to="`/club/send-ticket`">
				ارسال تیکت جدید
			</router-link>
		</div>
		<div v-else>

			<router-link class="btn btn-outline-dark mb-3" :to="`/club/send-ticket`">
				ارسال تیکت جدید
			</router-link>

			<b-overlay :show="isLoading" class="tickets">
				<table class="table table-striped bg-white text-center">
					<thead>
						<tr>
							<th>{{ $t("param.record") }}</th>
							<th v-for="field in fields" v-if="field.showCell" :key="field.key">
								{{ $t("param.ticket." + field.key) }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in items" @click="onShowDatails(item)">
							<td>
								{{ index + (currentPage - 1) * perPage + 1 }}
							</td>
							<td v-for="field in fields" v-if="field.showCell">
								{{item[field.key]}}
							</td>
							<td>
								<router-link class="btn btn-outline-dark" :to="`/club/show-ticket/${item.trackingCode}`">
									<i class="fa fa-link"></i> مشاهده تیکت
								</router-link>
							</td>
						</tr>
					</tbody>
				</table>
				<b-pagination dir="ltr"
							  pills
							  @input="initTable"
							  v-model="currentPage"
							  :total-rows="totalRows"
							  :per-page="perPage"
							  size="sm"></b-pagination>
			</b-overlay>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			transactionId: 0
		},

		data()
		{
			return {
				isLoading: false,
				showDetails: false,
				selected: {},
				items: [],
				fields: [
					{
						key: "title",
						showCell: true,
						shotDetails: true
					},					{
						key: "statusName",
						showCell: true,
						shotDetails: true
					},
					{
						key: "ticketRequestTypeName",
						showCell: true,
						shotDetails: true
					},
					{
						key: "trackingCode",
						showCell: true,
						shotDetails: true
					},
					{
						key: "ticketPriorityName",
						showCell: true,
						shotDetails: true,
					},
					{
						key: "persianCreateDate",
						showCell: true,
						shotDetails: true,
					},
					{
						key: "createTime",
						showCell: true,
						shotDetails: true,
					}
				],
				totalRows: 1,
				currentPage: 1,
				perPage: 5
			};
		},

		beforeMount()
		{
			this.initTable();
		},

		mounted()
		{
			this.totalRows = this.items.length;
		},

		methods: {
			initTable()
			{
				this.isLoading = true;
				const data = {
					Search: "",
					Start: (this.currentPage - 1) * this.perPage,
					Length: this.perPage
				};

				axios({ method: "post", url: "/api/App/GetTickets", data: data })
					.then(response =>
					{
						this.items = response.data.meta.tickets;
						this.totalRows = response.data.meta.totalRows;
						this.isLoading = false;
					})
					.catch(error => { });
			},

			onShowDatails(item)
			{
				this.selected = item;
				this.showDetails = true;
			}
		}
	};
</script>
<style scoped>
	.tickets {
		width: 100%;
		min-height: 200px;
	}
</style>

